import { startCase } from 'lodash-es';

export type EventsValue = Record<string, Record<string, boolean>>;

export function eventsValueToOptions(eventsValue: EventsValue): string[] {
  return Object.entries(eventsValue).flatMap(([entity, events]) =>
    Object.keys(events).map((event) => `${entity}.${event}`),
  );
}

export function eventsValueToValue(eventsValue: EventsValue): string[] {
  return Object.entries(eventsValue).flatMap(([entity, events]) =>
    Object.entries(events).flatMap(([event, value]) => (value ? [`${entity}.${event}`] : [])),
  );
}

export function valueToEventsValue(value: string[]): EventsValue {
  return value.reduce((acc, item) => {
    const [entity, event] = item.split('.');
    return {
      ...acc,
      [entity]: {
        ...acc[entity],
        [event]: true,
      },
    };
  }, {} as EventsValue);
}

export function getOptionLabel(option: string) {
  return startCase(option.replace(/[._]/g, ' ').toLowerCase());
}
